import {
  GET_USERMACHINE_FAILURE,
  GET_USERMACHINE_REQUEST,
  GET_USERMACHINE_SUCCESS,
  GET_USERS_FOR_PO_REQUEST,
  GET_USERS_FOR_PO_SUCCESS,
  GET_USERS_FOR_PO_FAILURE,
} from "./userMachineTypes";

const initialState = {
  loading: false,
  labels: [],
  error: "",
};

const getUserMachineReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USERMACHINE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_USERMACHINE_SUCCESS:
      return {
        loading: false,
        labels: action.payload,
        error: "",
      };
    case GET_USERMACHINE_FAILURE:
      return {
        loading: false,
        labels: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForUsersForPo = {
  loading: false,
  users: [],
  error: "",
};

const getUsersForPoReducer = (state = initialStateForUsersForPo, action) => {
  switch (action.type) {
    case GET_USERS_FOR_PO_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_USERS_FOR_PO_SUCCESS:
      return {
        loading: false,
        users: action.payload,
        error: "",
      };
    case GET_USERS_FOR_PO_FAILURE:
      return {
        loading: false,
        users: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export { getUserMachineReducer, getUsersForPoReducer };
